const defaultState = {
  selectedTab: 'signIn',
};

const app = (state = defaultState, action) => {
  switch (action.type) {
    case 'SWITCH_TAB':
      return Object.assign({}, state, { selectedTab: action.value });
    default:
      return state;
  }
};

export default app;
